module.exports = __webpack_public_path__ + "img/uporabnik-zig.9db2df31.svg";